import React from 'react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

interface PassMappingLearnedBannerProps {
  learnedPrefillCount: number
}

export default function PassMappingLearnedBanner({
  learnedPrefillCount
}: PassMappingLearnedBannerProps) {
  if (learnedPrefillCount <= 0) return null

  const rowLabel = learnedPrefillCount === 1 ? 'row' : 'rows'

  return (
    <div
      role="status"
      data-testid="pass-mapping-learned-banner"
      className="mb-3 flex gap-3 rounded-lg border border-blueprint-blue/20 bg-blueprint-blue/5 px-4 py-3 text-sm text-blueprint-blue"
    >
      <InformationCircleIcon className="h-5 w-5 flex-shrink-0" aria-hidden />
      <div className="min-w-0">
        <p className="font-semibold">Suggested mappings applied</p>
        <p className="mt-1 text-[12px] text-heritage-grey">
          Based on pass names mapped by previous users, we pre-filled {learnedPrefillCount} {rowLabel}.
          Review the mappings below — correct anything that looks wrong, then continue.
        </p>
      </div>
    </div>
  )
}
